import { API } from "../APIs/index";
import { Tokens } from "../Interfaces/Interfaces";
import { TokenValidator } from "./TokenValidator";

export default class ConfigService {
  tokens: any | Tokens;
  get = API.configuration + "get/";
  post = API.configuration + "post/";
  delete = API.configuration + "delete/";
  put = API.configuration + "put/";
  otp = API.otp + "post/";
  paystack = API.paystack + "get/";

  Areas: any;

  constructor() {
    this.tokens = TokenValidator();
  }

  async uploadFile(data: FormData) {
    try {
      let response = await fetch(this.post + `fileManager/UploadFiles`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${this.tokens.access_token}`,
          "x-api-key": `${process.env.REACT_APP_API_KEY}`,
        },
        body: data,
      });

      return await response.json();
    } catch (err) {
      throw err;
    }
  }

  async getRegionService() {
    try {
      let response = await fetch(this.get + `Region/nameandids`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.tokens.access_token}`,
          "x-api-key": `${process.env.REACT_APP_API_KEY}`,
        },
      });

      return await response.json();
    } catch (err) {
      throw err;
    }
  }

  async getRegionStateService(data: any) {
    try {
      let response = await fetch(this.get + `Region/regionstates/${data}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.tokens.access_token}`,
          "x-api-key": `${process.env.REACT_APP_API_KEY}`,
        },
      });

      return await response.json();
    } catch (err) {
      throw err;
    }
  }

  async getRegionTerritoryService(data: any) {
    try {
      let response = await fetch(
        this.get + `Region/regionterritories/${data}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.tokens.access_token}`,
            "x-api-key": `${process.env.REACT_APP_API_KEY}`,
          },
        }
      );

      return await response.json();
    } catch (err) {
      throw err;
    }
  }

  async getAgentAccounts(id: any) {
    try {
      let response = await fetch(this.get + `account/agent/${id}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.tokens.access_token}`,
          "x-api-key": `${process.env.REACT_APP_API_KEY}`,
        },
      });

      return await response.json();
    } catch (err) {
      throw err;
    }
  }

  async getAgentAccount(phoneNumber: any) {
    try {
      let response = await fetch(this.get + `account/default/${phoneNumber}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.tokens.access_token}`,
          "x-api-key": `${process.env.REACT_APP_API_KEY}`,
        },
      });

      return await response.json();
    } catch (err) {
      throw err;
    }
  }

  async getOTP(data: any) {
    try {
      let response = await fetch(this.otp + `sendOtp`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.tokens.access_token}`,
          "x-api-key": `${process.env.REACT_APP_API_KEY}`,
        },
        body: JSON.stringify(data),
      });

      return await response.json();
    } catch (err) {
      throw err;
    }
  }

  async getState() {
    try {
      let response = await fetch(this.get + `state/nameAndIds`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.tokens.access_token}`,
          "x-api-key": `${process.env.REACT_APP_API_KEY}`,
        },
      });

      return await response.json();
    } catch (err) {
      throw err;
    }
  }

  async getUserStates() {
    try {
      let response = await fetch(this.get + `state/statesInUserRegion`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.tokens.access_token}`,
          "x-api-key": `${process.env.REACT_APP_API_KEY}`,
        },
      });

      return await response.json();
    } catch (err) {
      throw err;
    }
  }

  async getAreasByState(stateId: string) {
    try {
      let response = await fetch(this.get + `state/lgas/${stateId}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.tokens.access_token}`,
          "x-api-key": `${process.env.REACT_APP_API_KEY}`,
        },
      });

      return await response.json();
    } catch (err) {
      throw err;
    }
  }

  async getBanks() {
    try {
      // let response = await fetch(this.get + `bank/nameAndIds`, {
      let response = await fetch(this.get + `Bank/nameandid`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.tokens.access_token}`,
          "x-api-key": `${process.env.REACT_APP_API_KEY}`,
        },
      });

      return await response.json();
    } catch (err) {
      throw err;
    }
  }
}
